import { Card, CardContent, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from "clsx";
import { AuthGuard, CreateActivityModal, ErrorMessage, LoadingIndicator, Page, RenderGuard } from 'components';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Teacher } from 'services';
import { curriculum_manager } from "utils/constants";
import useErrorCatcher from "utils/useErrorCatcher";
import useRouter from 'utils/useRouter';
import TeacherRow from "./components/TeacherRow";
import Toolbar from "./components/Toolbar";

const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  spinner: {
    marginTop: theme.spacing(3),
  },
  content: {
    overflowX: "auto"
  },
  table: {
    border: "1px #eeeeee solid",
    overflowX: "auto"
  },
  row: {
    display: "flex"
  },
  header: {
    border: "1px #eeeeee solid",
    flex: "1",
    overflowX: "auto"
  },
  card: {
    marginTop: theme.spacing(2)
  },
  hint: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(3)
  },
  title: {
    textAlign: "center",
    marginTop: theme.spacing(2)
  }
}));

let mounted = false;

const Overview = () => {
  const [date, setDate] = useState(moment());
  const [view, setView] = useState('dayGridMonth');
  const [loading, setLoading] = useState(false);
  const [teachers, setTeachers] = useState([]);
  const runAsyncBlock = useErrorCatcher(error => setErrorMessage(error && error.message));
  const [errorMessage, setErrorMessage] = useState("");
  const [selected, setSelected] = useState(null);
  const router = useRouter();
  const [openActivity, setOpenActivity] = useState(false);

  useEffect(() => {
  }, [date])

  useEffect(() => {
    mounted = true;
    return () => { mounted = false };
  }, []);

  useEffect(() => {
    reload();
  }, [date]); //eslint-disable-line

  const reload = async () => {
    setLoading(true);
    await runAsyncBlock(async () => {
      let { models } = await Teacher.list({
        query: {
          limit: 9999
        }
      });
      if (mounted) {
        setTeachers(models);
      }
    }).finally(() => { mounted && setLoading(false) });
  }

  const classes = useStyles();

  const handleViewChange = view => {
    setView(view);
  };

  const handleDateToday = () => {
    setDate(moment());
  };

  const handleDatePrev = () => {
    setDate(moment(date).subtract(1, "weeks"));
  };

  const handleDateNext = () => {
    setDate(moment(date).add(1, "weeks"));
  };

  const handleActivityOpen = (slot) => {
    setSelected(slot);
    setOpenActivity(true);
  }

  const handleActivityClose = () => {
    setSelected(null);
    setOpenActivity(false);
  }

  return (
    <AuthGuard roles={[curriculum_manager]}>
      <Page className={classes.root} title="Lesson Slots">
        <ErrorMessage message={errorMessage} />
        <Toolbar
          date={date}
          onDateNext={handleDateNext}
          onDatePrev={handleDatePrev}
          onDateToday={handleDateToday}
          onViewChange={handleViewChange}
          view={view}
        />
        <LoadingIndicator className={classes.spinner} variant="card" active={loading} />
        <RenderGuard renderIf={!loading}>
          <Card className={classes.card}>
            <Typography variant="h3" className={classes.title}>
              {moment(date).startOf("week").format("DD")} - {moment(date).endOf("week").format("DD")} {date.format('MMMM YYYY')}
            </Typography>
            <CardContent className={classes.content}>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow className={classes.row}>
                    <TableCell className={clsx(classes.header)} align="center">Coaches</TableCell>
                    {days.map((day, index) => (
                      <TableCell className={clsx(classes.header)} align="center" key={index}>{day}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {teachers.map((teacher, index) => (
                    <TeacherRow handleActivityOpen={handleActivityOpen} key={index} teacher={teacher} date={date} />
                  ))}
                </TableBody>
              </Table>
            </CardContent>
          </Card>
        </RenderGuard>
        <CreateActivityModal onClose={handleActivityClose} onCreate={id => router.history.push(`/activities/${id}/summary`)} open={selected && openActivity} slot_id={selected} />
      </Page>
    </AuthGuard>
  );
};

Overview.propTypes = {
  className: PropTypes.string
};

export default Overview;
